import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import ArrayList from '../../../../../java/util/ArrayList';
import Serializable from '../../../../../java/io/Serializable';
var NodeBase = /*#__PURE__*/function () {
  function NodeBase() {
    _classCallCheck(this, NodeBase);
    NodeBase.constructor_.apply(this, arguments);
  }
  _createClass(NodeBase, [{
    key: "hasChildren",
    value: function hasChildren() {
      for (var i = 0; i < 4; i++) if (this._subnode[i] !== null) return true;
      return false;
    }
  }, {
    key: "isPrunable",
    value: function isPrunable() {
      return !(this.hasChildren() || this.hasItems());
    }
  }, {
    key: "addAllItems",
    value: function addAllItems(resultItems) {
      resultItems.addAll(this._items);
      for (var i = 0; i < 4; i++) if (this._subnode[i] !== null) this._subnode[i].addAllItems(resultItems);
      return resultItems;
    }
  }, {
    key: "getNodeCount",
    value: function getNodeCount() {
      var subSize = 0;
      for (var i = 0; i < 4; i++) if (this._subnode[i] !== null) subSize += this._subnode[i].size();
      return subSize + 1;
    }
  }, {
    key: "size",
    value: function size() {
      var subSize = 0;
      for (var i = 0; i < 4; i++) if (this._subnode[i] !== null) subSize += this._subnode[i].size();
      return subSize + this._items.size();
    }
  }, {
    key: "addAllItemsFromOverlapping",
    value: function addAllItemsFromOverlapping(searchEnv, resultItems) {
      if (!this.isSearchMatch(searchEnv)) return null;
      resultItems.addAll(this._items);
      for (var i = 0; i < 4; i++) if (this._subnode[i] !== null) this._subnode[i].addAllItemsFromOverlapping(searchEnv, resultItems);
    }
  }, {
    key: "visitItems",
    value: function visitItems(searchEnv, visitor) {
      for (var i = this._items.iterator(); i.hasNext();) visitor.visitItem(i.next());
    }
  }, {
    key: "hasItems",
    value: function hasItems() {
      return !this._items.isEmpty();
    }
  }, {
    key: "remove",
    value: function remove(itemEnv, item) {
      if (!this.isSearchMatch(itemEnv)) return false;
      var found = false;
      for (var i = 0; i < 4; i++) if (this._subnode[i] !== null) {
        found = this._subnode[i].remove(itemEnv, item);
        if (found) {
          if (this._subnode[i].isPrunable()) this._subnode[i] = null;
          break;
        }
      }
      if (found) return found;
      found = this._items.remove(item);
      return found;
    }
  }, {
    key: "visit",
    value: function visit(searchEnv, visitor) {
      if (!this.isSearchMatch(searchEnv)) return null;
      this.visitItems(searchEnv, visitor);
      for (var i = 0; i < 4; i++) if (this._subnode[i] !== null) this._subnode[i].visit(searchEnv, visitor);
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return this._items;
    }
  }, {
    key: "depth",
    value: function depth() {
      var maxSubDepth = 0;
      for (var i = 0; i < 4; i++) if (this._subnode[i] !== null) {
        var sqd = this._subnode[i].depth();
        if (sqd > maxSubDepth) maxSubDepth = sqd;
      }
      return maxSubDepth + 1;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      var isEmpty = true;
      if (!this._items.isEmpty()) isEmpty = false;else for (var i = 0; i < 4; i++) if (this._subnode[i] !== null) if (!this._subnode[i].isEmpty()) {
        isEmpty = false;
        break;
      }
      return isEmpty;
    }
  }, {
    key: "add",
    value: function add(item) {
      this._items.add(item);
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Serializable];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._items = new ArrayList();
      this._subnode = new Array(4).fill(null);
    }
  }, {
    key: "getSubnodeIndex",
    value: function getSubnodeIndex(env, centrex, centrey) {
      var subnodeIndex = -1;
      if (env.getMinX() >= centrex) {
        if (env.getMinY() >= centrey) subnodeIndex = 3;
        if (env.getMaxY() <= centrey) subnodeIndex = 1;
      }
      if (env.getMaxX() <= centrex) {
        if (env.getMinY() >= centrey) subnodeIndex = 2;
        if (env.getMaxY() <= centrey) subnodeIndex = 0;
      }
      return subnodeIndex;
    }
  }]);
  return NodeBase;
}();
export { NodeBase as default };